import React, { useEffect, useState } from "react";
import Style from "../style/header.module.scss";
import StickyBox from "react-sticky-box";
import Sidebar from "./Sidebar";
import Overlay from "./Overlay";

const Header = () => {
  const [backcolor, setBackColor] = useState(false);
  const [line, setLine] = useState(0);
  const [nav, setNav] = useState(false);
  const [overlay, setOverlay] = useState(false);

  useEffect(() => {
    const handleLine = () => {
      const scrolled = window.scrollY;
      const lineHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const line = (scrolled / lineHeight) * 100;
      setLine(line);
    };
    window.addEventListener("scroll", handleLine);
    return () => {
      window.removeEventListener("scroll", handleLine);
    };
  }, [line]);

  useEffect(() => {
    const handleColor = () => {
      const scrolled = window.scrollY;
      setBackColor(scrolled > 100);
    };

    window.addEventListener("scroll", handleColor);
    return () => {
      window.removeEventListener("scroll", handleColor);
    };
  }, []);

  const handleNavbar = () => {
    setNav(true);
    setOverlay(true);
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  };

  const handleNav = () => {
    setNav(false);
    setOverlay(false);
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };

  return (
    <>
      <StickyBox style={{ zIndex: 9 }}>
        <div
          className={`${Style.container} ${backcolor ? Style.stickyBack : ""} 
          `}
        >
          <div className={Style.wrapper}>
            <div className={`${Style.sidebar} ${nav ? Style.active : ""}`}>
              <Sidebar handleNav={handleNav} />
            </div>
            <>{overlay && <Overlay />}</>
            <div className={Style.header}>
              <div className={Style.headerleft}>
                <div className={Style.icon} onClick={handleNavbar}>
                  <h2>☰</h2>
                </div>
                <div className={Style.logo}>
                  <a href="/">One Dial USA</a>
                </div>
              </div>
              <div className={Style.headerRight}>
                <ul>
                  <li>
                    <a href="/dashboard/new">
                      <img
                        src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/nav_listing_icon.svg"
                        alt="Icon"
                        loading="lazy"
                      />
                      Free Listing <strong>bussiness</strong>
                    </a>
                  </li>
                  <li>
                    <a href="/vendor/login">
                      <i className="fa-regular fa-user"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={Style.borderLine} style={{ width: `${line}%` }}></div>
        </div>
      </StickyBox>
    </>
  );
};

export default Header;
